// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const StreamingLive_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 8.25A3.75 3.75 0 1 0 15.75 12 3.75 3.75 0 0 0 12 8.25Zm0 6A2.25 2.25 0 1 1 14.25 12 2.25 2.25 0 0 1 12 14.25Zm6.91.67A7.5 7.5 0 0 1 17.59 17a.75.75 0 0 1-1.117-1 5.995 5.995 0 0 0 0-8 .75.75 0 1 1 1.117-1 7.51 7.51 0 0 1 1.32 7.92ZM6.47 9.664A6 6 0 0 0 7.524 16a.75.75 0 0 1-1.117 1 7.493 7.493 0 0 1 0-10 .751.751 0 1 1 1.12 1A6 6 0 0 0 6.47 9.666ZM23.25 12a11.2 11.2 0 0 1-3.215 7.875.75.75 0 1 1-1.07-1.05 9.74 9.74 0 0 0 0-13.646.751.751 0 1 1 1.07-1.054A11.2 11.2 0 0 1 23.25 12ZM5.035 18.823a.75.75 0 1 1-1.07 1.052 11.24 11.24 0 0 1 0-15.75.75.75 0 1 1 1.07 1.05 9.74 9.74 0 0 0 0 13.646Z',
  viewBox: '0 0 24 24',
  glyph: 'StreamingLive_Stroke2_Corner0_Rounded',
})
